module.exports = __webpack_public_path__ + "static/img/4.e697933.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toutiao/4.png
// module id = ITw6
// module chunks = 156